import React, { useEffect } from "react";
import Breadcrumb_comp from "../../components/common_components/breadcrumb-comp/Breadcrumb_comp";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utils/common";
import {
  getAllProductsYouLike,
  getProduct,
} from "../../features/products/productsSlice";
import Product_Image from "./product_image/Product_Image";
import "./Product_Description.css";
import Product_Inner_Description from "./product_inner_description/Product_Inner_Description";
import Product_Content from "./product_content/Product_Content";
import Extra_Feature from "./extra_feature/Extra_Feature";
import Know_More from "./know_more/Know_More";
import {
  AvgReviewRating,
  getAllReview,
} from "../../features/review_rating/review_ratingSlice";
import TopReviews from "./top_reviews/TopReviews";
import Reccomndation from "./reccomndation/Reccomndation";
import Product_Banner from "./product_inner_description/product-banner/Product_Banner";
import Explore_The_Categories from "./product_inner_description/explore-the-categories/Explore_The_Categories";
import Banner2 from "./product_inner_description/banner2/Banner2";
import FeaturesSection from "./product_inner_description/features-section/Features_Section";

const Product_Description = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const product = useSelector((state) => state?.product?.product);

  useEffect(() => {
    const deid = decodeId(id);
    dispatch(getProduct(deid));
  }, [dispatch, id]);

  const all_review = useSelector((state) => state.reviewRating.all_review);

  useEffect(() => {
    dispatch(getAllReview({ id: product?.id }));
  }, [dispatch, product?.id]);
  const avgreview = useSelector((state) => state.reviewRating.avg_rating);

  useEffect(() => {
    dispatch(AvgReviewRating({ id: product?.id }));
  }, [dispatch, product?.id]);

  const You_May_Also_LikeProduct = useSelector(
    (state) => state.product.allProducts_you_like,
  );
  useEffect(() => {
    dispatch(
      getAllProductsYouLike({
        category_id: product?.p_category_id,
      }),
    );
  }, [dispatch, product]);
 const cart = useSelector((state) => state.cart.allCarts);
  // console.log(all_review,"reviewsssss")

  return (
    <section className="Product_Description">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          // { label: product?.p_category?.name, link: `/product-listing/${product?.p_category_id}`, isActive: false },
          {
            label: product?.p_category?.name,
            link: `/product-listing/${
              product?.p_category_id
            }?category_name=${encodeURIComponent(
              product?.p_category?.name,
            )}&category_image=${encodeURIComponent(
              product?.p_category?.image,
            )}`,
            isActive: false,
          },
          { label: product?.name, link: "", isActive: true },
        ]}
        additionalClass="groceries"
      />
      <div className="Product_Description_holder">
        <div className="container">
          <div className="product_description_container">
            <div className="product_information">
              <div className="row justify-content-center">
                <div className="col-lg-6 ">
                  {product ? <Product_Image image={product} /> : <></>}
                </div>

                <div className="col-lg-6 col-md-12">
                  <Product_Inner_Description
                    product={product}
                    avgreview={avgreview}
                  />
                </div>
              </div>

              <Product_Content product={product} />
            </div>
          </div>
        </div>
      </div>

      <Product_Banner />

      <Explore_The_Categories />

      <FeaturesSection product={product} />

      {/* <Reccomndation product={You_May_Also_LikeProduct?.data} /> */}

      <Banner2 />

      <Reccomndation product={You_May_Also_LikeProduct?.data} />

      {/* <Extra_Feature /> */}

      {/* <Know_More product={product} /> */}

      {all_review?.data?.length > 0 && (
        <div className="top_3_review_section">
          <TopReviews all_review={all_review} product={product} />
        </div>
      )}
    </section>
  );
};

export default Product_Description;
